const wrapper = document.querySelector(".J-wrapper");
const Jcarousel = document.querySelector(".J-carousel");
const JfirstCardWidth = document.querySelector(".J-card").offsetWidth;
const JarrowBtns = document.querySelectorAll(".J-wrapper i");
const JcarouselChildrens = [...Jcarousel.children];
let isDragging = false,
  isAutoPlay = true,
  startX,
  startScrollLeft,
  timeoutId;
// Get the number of cards that can fit in the carousel at once
let JcardPerView = Math.round(Jcarousel.offsetWidth / JfirstCardWidth);
// Insert copies of the last few cards to beginning of carousel for infinite scrolling
JcarouselChildrens.slice(-JcardPerView)
  .reverse()
  .forEach((card) => {
    Jcarousel.insertAdjacentHTML("afterbegin", card.outerHTML);
  });
// Insert copies of the first few cards to end of carousel for infinite scrolling
JcarouselChildrens.slice(0, JcardPerView).forEach((card) => {
  Jcarousel.insertAdjacentHTML("beforeend", card.outerHTML);
});
// Scroll the carousel at appropriate postition to hide first few duplicate cards on Firefox
Jcarousel.classList.add("no-transition");
Jcarousel.scrollLeft = Jcarousel.offsetWidth;
Jcarousel.classList.remove("no-transition");
// Add event listeners for the arrow buttons to scroll the carousel left and right
JarrowBtns.forEach((btn) => {
  btn.addEventListener("click", () => {
    Jcarousel.scrollLeft +=
      btn.id == "left" ? -JfirstCardWidth : JfirstCardWidth;
  });
});
const dragStart = (e) => {
  isDragging = true;
  Jcarousel.classList.add("dragging");
  // Records the initial cursor and scroll position of the carousel
  startX = e.pageX;
  startScrollLeft = Jcarousel.scrollLeft;
};
const dragging = (e) => {
  if (!isDragging) return; // if isDragging is false return from here
  // Updates the scroll position of the carousel based on the cursor movement
  Jcarousel.scrollLeft = startScrollLeft - (e.pageX - startX);
};
const dragStop = () => {
  isDragging = false;
  Jcarousel.classList.remove("dragging");
};
const infiniteScroll = () => {
  // If the carousel is at the beginning, scroll to the end
  if (Jcarousel.scrollLeft === 0) {
    Jcarousel.classList.add("no-transition");
    Jcarousel.scrollLeft = Jcarousel.scrollWidth - 2 * Jcarousel.offsetWidth;
    Jcarousel.classList.remove("no-transition");
  }
  // If the carousel is at the end, scroll to the beginning
  else if (
    Math.ceil(Jcarousel.scrollLeft) ===
    Jcarousel.scrollWidth - Jcarousel.offsetWidth
  ) {
    Jcarousel.classList.add("no-transition");
    Jcarousel.scrollLeft = Jcarousel.offsetWidth;
    Jcarousel.classList.remove("no-transition");
  }
  // Clear existing timeout & start autoplay if mouse is not hovering over carousel
  clearTimeout(timeoutId);
  if (!wrapper.matches(":hover")) autoPlay();
};
const autoPlay = () => {
  if (window.innerWidth < 800 || !isAutoPlay) return; // Return if window is smaller than 800 or isAutoPlay is false
  // Autoplay the carousel after every 2500 ms
  timeoutId = setTimeout(() => (Jcarousel.scrollLeft += JfirstCardWidth), 5000);
};
autoPlay();
Jcarousel.addEventListener("mousedown", dragStart);
Jcarousel.addEventListener("mousemove", dragging);
document.addEventListener("mouseup", dragStop);
Jcarousel.addEventListener("scroll", infiniteScroll);
wrapper.addEventListener("mouseenter", () => clearTimeout(timeoutId));
wrapper.addEventListener("mouseleave", autoPlay);